import * as React from 'react'

import { Box } from '~ui/components/layout/Box'

type TBoxProps = Pick<
  PropsOf<typeof Box>,
  | 'bgColor'
  | 'padding'
  | 'shadowInset'
  | 'width'
  | 'maxWidth'
  | 'minWidth'
  | 'maxHeight'
  | 'minHeight'
  | 'height'
  | 'border'
  | 'borderLeft'
  | 'borderRight'
  | 'borderTop'
  | 'borderBottom'
>

type TProps = RequiredChildren & TBoxProps & TestingProps

/**
 * Basic drop-in content component wrapping it’s children in colored box adding some inset box shadow etc.
 * It also automatically figures out text color with appropriate contrast.
 */
export const Dropin: React.FC<TProps> = ({
  bgColor,
  children,
  shadowInset = `medium`,
  padding = `medium`,
  dataTestId,
  ...chakraProps
}) => {
  return (
    <Box
      {...chakraProps}
      dataTestId={dataTestId}
      padding={padding}
      bgColor={bgColor}
      shadowInset={shadowInset}
    >
      {children}
    </Box>
  )
}
